import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../common/form/validation/global-directives.module';
import { PlanwertRoutingModule } from './planwert-routing.module';
import { PlanwertPageComponent } from './planwert-page/planwert-page.component';
import { PlanwertListComponent } from './planwert-list/planwert-list.component';
import { PlanwertTableComponent } from './planwert-table/planwert-table.component';
import { PlanwertFilterComponent } from './planwert-filter/planwert-filter.component';
import { PipeModule } from '../common/pipe/pipe.module';
import { PlanwertDetailComponent } from './planwert-detail/planwert-detail.component';
import { PlanwertDetailFormComponent } from './planwert-detail-form/planwert-detail-form.component';
import { FormComponentsModule } from '../common/form/components/form-components.module';

@NgModule({ declarations: [
    PlanwertPageComponent,
    PlanwertListComponent,
    PlanwertTableComponent,
    PlanwertFilterComponent,
    PlanwertDetailComponent,
    PlanwertDetailFormComponent,
],
exports: [], imports: [
    CommonModule,
    MaterialModule,
    ServiceModule,
    PlanwertRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    GlobalDirectivesModule,
    PipeModule,
    FormComponentsModule,
], providers: [
    provideHttpClient(withInterceptorsFromDi()),
] })
export class PlanwertModule {
}
